import React, { useState, useEffect } from 'react';
import { Button, Card, Spinner } from 'react-bootstrap';
import { FaArrowLeft, FaPaperclip, FaDownload } from 'react-icons/fa';
import { buscarAnexosFaq, downloadAnexoFaq } from '~/Services/Service';

const DetalhesFAQ = ({ item, onVoltar }) => {
  var [anexos, setAnexos] = useState([]);
  var [loadingAnexos, setLoadingAnexos] = useState(false);

  useEffect(function() {
    if (item && item.codigo) {
      setLoadingAnexos(true);
      buscarAnexosFaq(item.codigo)
        .then(function(res) {
          setAnexos(res || []);
        })
        .catch(function() {
          setAnexos([]);
        })
        .finally(function() {
          setLoadingAnexos(false);
        });
    }
  }, [item]);

  var handleDownload = function(anexo) {
    downloadAnexoFaq(anexo.codigo, anexo.nome_arquivo).catch(function() {
      console.error('Erro ao baixar anexo:', anexo.nome_arquivo);
    });
  };

  return (
    <Card className="shadow-sm" style={{ maxHeight: 'calc(100vh - 200px)', display: 'flex' }}>
      <Card.Body style={{ overflowY: 'auto' }}>
        <div className="d-flex justify-content-end mb-3">
          <Button variant="outline-secondary" onClick={onVoltar}>
            <FaArrowLeft className="mr-1" /> Voltar
          </Button>
        </div>

        <span className="text-muted" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          {item.nome_assunto}
        </span>
        <h5 className="mt-1 mb-3" style={{ fontWeight: 600 }}>
          {item.titulo}
        </h5>
        <hr />
        <div style={{ fontSize: '0.95rem', lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: item.texto }} />

        <div className="mt-3">
          <strong><FaPaperclip className="mr-1" />Anexos:</strong>
          {loadingAnexos ? (
            <div className="mt-2">
              <Spinner animation="border" size="sm" /> Carregando...
            </div>
          ) : anexos.length > 0 ? (
            <ul className="list-unstyled mt-2">
              {anexos.map(function(anexo) {
                return (
                  <li key={anexo.codigo} className="mb-2">
                    <Button
                      variant="link"
                      className="p-0 text-primary"
                      onClick={function() { handleDownload(anexo); }}
                    >
                      <FaDownload className="mr-1" />
                      {anexo.nome_arquivo}
                    </Button>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="text-muted mt-2 mb-0">Nenhum anexo</p>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default DetalhesFAQ;
